<template>
  <div class="phone_consultation" @click.stop="dialPhone"></div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "phone_consultation_index",
  data() {
    return {
      href: ""
    };
  },
  props: {
    editData: {
      type: Object,
      default: null
    }
  },
  watch: {},
  methods: {
    dialPhone(data) {
      this.templet.clickTime(() => {
        this.$message.warning(i18n.t('components_set_link_components_phone_consultation_2462'));
      });

      // let isMobile = false
      // if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      //   isMobile = true
      // }
      // if(isMobile) {
      //   let url = data.fun.information_advisory.value
      //   if(data.fun.type == 'telephone_advisory') {
      //     url = data.fun.telephone_advisory.value
      //   }
      //   if(url !== '') {
      //     this.href = 'tel:'+ url
      //   }
      // } else {
      //   this.$message.warning('该功能无法在桌面浏览器中启动')
      // }
    }
  },
  components: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.phone_consultation {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/phone_consultation.vue